import React from 'react';
import SETTINGS from "../../../settings";
import {pullSubdomainStyleFromCookie} from "../../../utils/subdomains/configHandlers";

function StaticMapboxImage({ longitude, latitude, img_height=300, img_width=600 }) {
    // Replace 'YOUR_ACCESS_TOKEN' with your Mapbox access token
    const accessToken = SETTINGS.mapboxToken;

    // pull marker color from cookie
    const markerColor = pullSubdomainStyleFromCookie()['primary-color'] || 'blue'

    // Define the URL to fetch the static map image
    const imageUrl = `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/pin-l+A0DF00(${longitude},${latitude})/${longitude},${latitude},17/${Math.floor(img_width)}x${Math.floor(img_height)}?access_token=${SETTINGS.mapboxToken}`

    return (
        <div>
            <img src={imageUrl} alt="Map" />
        </div>
    );
}

export default StaticMapboxImage;